import { type ComputeExpression } from '../ComputeExpression.ts';

export function computeExpressionToJsonContent(
  value: ComputeExpression | null | undefined,
) {
  if (!value) return null;

  return {
    type: 'root' as const,
    content: [
      {
        type: 'node' as const,
        attrs: { class: 'compute-expression-node' },
        content: value.value,
      },
    ],
  };
}
